import styled from 'styled-components';
import { Body6, Body6Template } from '../../../../shared/typography';

export const Container = styled(Body6).attrs({ as: 'div' })`
  color: ${({ theme }) => theme.medGray};
  margin-bottom: 40px;

  p {
    color: ${({ theme }) => theme.medGray};
    margin: 0 0 10px;
    font-size: ${Body6Template.fontSize};
    font-weight: ${Body6Template.fontWeight};
    font-style: normal;
    line-height: ${Body6Template.lineHeight};
    letter-spacing: ${Body6Template.letterSpacing};
  }

  p:first-child {
    margin-top: 0;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.oneAppBlue};
  }
`;
